import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatusComponent } from './components/status/status.component';
import { DialogComponent } from './components/dialog/dialog.component';
import { MaterialModule } from '@app/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { KeyValueResponseTableComponent } from './components/key-value-response-table/key-value-response-table.component';
import { PhoneInputFieldComponent } from './components/phone-input-field/phone-input-field.component';
import { LanguageTranslationComponent } from './components/language-translation/language-translation.component';
import { ChannelsSelectorComponent } from './components/channels-selector/channels-selector.component';
import { BroadcastFiltersComponent } from './components/broadcast-filters/broadcast-filters.component';
import { SelectorConfirmPanelComponent } from './components/selector-confirm-panel/selector-confirm-panel.component';
import { SeniorCenterSelectorComponent } from './components/senior-center-selector/senior-center-selector.component';
import { RequestProgressComponent } from './components/request-progress/request-progress.component';
import { SearchBarComponent } from './components/search-bar/search-bar.component';
import { CustomShortDateFormatDirective, SchedulerFieldsComponent } from './components/scheduler-fields/scheduler-fields.component';
import { MultiSchedulerComponent } from './components/multi-scheduler/multi-scheduler.component';
import { CustomTableFilterComponent } from './components/custom-table-filter/custom-table-filter.component';
import { PreviewSheetComponent } from './components/preview-sheet/preview-sheet.component';
import { TagSelectorComponent } from './components/tag-selector/tag-selector.component';
import { DedupWarningModalComponent } from './components/dedup-warning-modal/dedup-warning-modal.component';
import { DuplicateCommunicationsListComponent } from './components/duplicate-communications-list/duplicate-communications-list.component';
import { CustomTableListComponent } from './components/custom-table-list/custom-table-list.component';
import { RecipientSelectorComponent } from './components/recipient-selector/recipient-selector.component';
import { ServiceDownWarnComponent } from './components/service-down-warn/service-down-warn.component';
import { MomentTimezonePipe } from './pipes/utcToTimezone.pipe';
import { AcceptTosPpDialogComponent } from './components/accept-tos-pp-dialog/accept-tos-pp-dialog.component';
import { FeatureAccessDirective } from './directives/featureAccess.directive';
import { DefaultRedirectComponent } from './components/default-redirect/default-redirect.component';
import { AutoFocusOnClickDirective } from './directives/auto-focus.directive';
import { CustomErrorTextComponent } from './components/custom-error-text/custom-error-text.component';
import { CustomTextEditorComponent } from './components/custom-text-editor/custom-text-editor.component';
import { QuillModule } from 'ngx-quill';
import Quill from 'quill';
import { Mention, MentionBlot } from 'quill-mention';
import { ServiceSelectorComponent } from './components/service-selector/service-selector.component';
import { CustomDatePickerComponent } from './components/custom-date-picker/custom-date-picker.component';

Quill.register({
  'modules/mention': Mention,
  'blots/mention': MentionBlot,
});

@NgModule({
    declarations: [
        StatusComponent,
        DialogComponent,
        KeyValueResponseTableComponent,
        PhoneInputFieldComponent,
        LanguageTranslationComponent,
        ChannelsSelectorComponent,
        BroadcastFiltersComponent, 
        SelectorConfirmPanelComponent, 
        SeniorCenterSelectorComponent, 
        RequestProgressComponent, 
        SearchBarComponent, 
        SchedulerFieldsComponent, 
        MultiSchedulerComponent, 
        CustomTableFilterComponent, 
        PreviewSheetComponent, 
        CustomShortDateFormatDirective, 
        TagSelectorComponent, 
        DedupWarningModalComponent,
        DuplicateCommunicationsListComponent, 
        CustomTableListComponent, 
        RecipientSelectorComponent, 
        ServiceDownWarnComponent, 
        MomentTimezonePipe,
        AcceptTosPpDialogComponent,
        FeatureAccessDirective,
        DefaultRedirectComponent,
        AutoFocusOnClickDirective,
        CustomErrorTextComponent,
        CustomTextEditorComponent,
        ServiceSelectorComponent,
        CustomDatePickerComponent
    ],
    imports: [
        CommonModule, 
        MaterialModule, 
        ReactiveFormsModule,
        FormsModule,
        QuillModule.forRoot(),
    ],
    exports: [
        StatusComponent, 
        DialogComponent, 
        KeyValueResponseTableComponent, 
        PhoneInputFieldComponent, 
        LanguageTranslationComponent,
        ChannelsSelectorComponent,
        BroadcastFiltersComponent, 
        SelectorConfirmPanelComponent, 
        SeniorCenterSelectorComponent, 
        RequestProgressComponent, 
        SearchBarComponent, 
        SchedulerFieldsComponent,
        MultiSchedulerComponent, 
        CustomTableFilterComponent, 
        PreviewSheetComponent, 
        CustomShortDateFormatDirective, 
        TagSelectorComponent,
        DuplicateCommunicationsListComponent, 
        CustomTableListComponent, 
        RecipientSelectorComponent, 
        ServiceDownWarnComponent,
        MomentTimezonePipe,
        AcceptTosPpDialogComponent,
        FeatureAccessDirective,
        AutoFocusOnClickDirective,
        CustomErrorTextComponent,
        CustomTextEditorComponent, 
        ServiceSelectorComponent,
        CustomDatePickerComponent
    ],
    providers: [
        MomentTimezonePipe
    ]
})
export class SharedModule {}
